import { ModuleNames } from "@ag-grid-community/core";
import { InfiniteRowModel } from "./infiniteRowModel/infiniteRowModel";
export var InfiniteRowModelModule = {
    moduleName: ModuleNames.InfiniteRowModelModule,
    rowModels: { infinite: InfiniteRowModel }
};
//# sourceMappingURL=infiniteRowModelModule.js.map